export default __webpack_public_path__ + "static/media/desktop-contact.4d32675b.png";